import { BaseRankedUserState, RankedUserStateType } from './BaseRankedUserState.ts';
export class RankedPlacementState extends BaseRankedUserState {
    finishedPlacementGames() {
        return this.numberOfPlacementGamesFinished >= this.numberOfPlacementGamesRequired;
    }
    getEndGameScreenText() {
        const remainingGames = this.numberOfPlacementGamesRequired - this.numberOfPlacementGamesFinished;
        const title = {
            key: 'strings:game.endGame.rankedUpdate.placementTitle',
            options: {
                gamesPlayedCount: this.numberOfPlacementGamesFinished,
                requiredGamesCount: this.numberOfPlacementGamesRequired
            }
        };
        const description = {
            key: 'strings:game.endGame.rankedUpdate.placementDescription',
            options: {
                count: remainingGames
            }
        };
        return {
            title: title,
            description: description
        };
    }
    getEndGameData() {
        return this.defaultEndGameData;
    }
    getFindGamePopupStatusText() {
        return {
            key: 'strings:colonistCommon.rankedState.placementGamesPlayed',
            options: {
                gamesPlayedCount: this.numberOfPlacementGamesFinished,
                count: this.numberOfPlacementGamesRequired
            }
        };
    }
    static deserialize(data) {
        const newPlacementState = new RankedPlacementState(data.numberOfPlacementGamesFinished, data.numberOfPlacementGamesRequired);
        return newPlacementState;
    }
    constructor(numberOfPlacementGamesFinished, numberOfPlacementGamesRequired){
        super(), this.type = RankedUserStateType.Placement;
        this.numberOfPlacementGamesFinished = numberOfPlacementGamesFinished;
        this.numberOfPlacementGamesRequired = numberOfPlacementGamesRequired;
        this.defaultEndGameData = {
            amount: '-',
            highest: false
        };
    }
}
